import { render, staticRenderFns } from "./LabelLIcon.vue?vue&type=template&id=4104101a&"
import script from "./LabelLIcon.vue?vue&type=script&lang=js&"
export * from "./LabelLIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports